import {Injectable} from '@angular/core';

interface TelegramHeader {
  name: string;
  value: string;
}

@Injectable({
  providedIn: 'root'
})
export class TelegramDetectorService {

  private static readonly TELEGRAM_HINTS = ['telegram', 't.me', 'tg://', 'tgwebapp'];
  private static readonly TELEGRAM_IN_APP_BROWSER_HEADER = 'X-Telegram-InApp-Browser';

  private resolvedFlag: boolean | null = null;

  isTelegramEnvironment(): boolean {
    if (this.resolvedFlag !== null) {
      return this.resolvedFlag;
    }

    this.resolvedFlag = this.evaluateEnvironment();
    return this.resolvedFlag;
  }

  getInAppBrowserHeader(): TelegramHeader | null {
    if (!this.isTelegramEnvironment()) {
      return null;
    }
    return {
      name: TelegramDetectorService.TELEGRAM_IN_APP_BROWSER_HEADER,
      value: 'true'
    };
  }

  getInAppBrowserTagValue(): string | null {
    return this.isTelegramEnvironment() ? 'true' : null;
  }

  getInAppBrowserTagName(): string {
    return TelegramDetectorService.TELEGRAM_IN_APP_BROWSER_HEADER;
  }

  private evaluateEnvironment(): boolean {
    const win = this.getWindow();
    const nav = this.getNavigator();

    if (win) {
      const telegramProxy = (win as any).TelegramWebviewProxy;
      if (telegramProxy) {
        return true;
      }
      const telegramApp = (win as any).Telegram?.WebApp;
      if (telegramApp) {
        return true;
      }
      const webkitProxy = (win as any).webkit?.messageHandlers?.TelegramWebviewProxy;
      if (webkitProxy) {
        return true;
      }
    }

    const documentReferrer = typeof document !== 'undefined' && document.referrer
      ? document.referrer.toLowerCase()
      : '';

    if (this.containsTelegramHints(documentReferrer)) {
      return true;
    }

    if (nav) {
      const userAgent = nav.userAgent ? nav.userAgent.toLowerCase() : '';
      if (this.containsTelegramHints(userAgent)) {
        return true;
      }

      const userAgentData = (nav as any).userAgentData;
      if (userAgentData?.brands && Array.isArray(userAgentData.brands)) {
        const hasTelegramBrand = userAgentData.brands
          .some((brand: any) => typeof brand.brand === 'string'
            && brand.brand.toLowerCase().includes('telegram'));
        if (hasTelegramBrand) {
          return true;
        }
      }
    }

    return false;
  }

  private containsTelegramHints(value: string): boolean {
    return TelegramDetectorService.TELEGRAM_HINTS
      .some(hint => value.includes(hint));
  }

  private getWindow(): Window | null {
    return typeof window === 'undefined' ? null : window;
  }

  private getNavigator(): Navigator | null {
    return typeof navigator === 'undefined' ? null : navigator;
  }
}
